import {createScopedComponent} from '../../utils/components';
import Popover from './Popover';

export default createScopedComponent(Popover, ['popover-header', 'popover-content']);
